/**
 * VP-300: tryb widoku REKLAMY | ORGANIC — jedno miejsce na klucz localStorage i na
 * decyzję „czy pokazywać rzeczy reklamowe".
 *
 * Klucz zapisuje wyłącznie toggle w sidebarze; czytają go sidebar, content-creator
 * (chowa górny pasek zakładek) i Centrum Integracji. Do VP-300 każde z tych miejsc
 * miało własną kopię stringa.
 */

export type AppViewMode = "reklamy" | "organic";

const VIEW_MODE_STORAGE_KEY = "viralpartners.sidebar.viewMode.v1";

/** Zapamiętany tryb; `reklamy` gdy nic nie zapisano albo nie ma `window` (SSR/testy). */
export function readViewMode(): AppViewMode {
  if (typeof window === "undefined") return "reklamy";
  return window.localStorage.getItem(VIEW_MODE_STORAGE_KEY) === "organic" ? "organic" : "reklamy";
}

export function writeViewMode(mode: AppViewMode): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(VIEW_MODE_STORAGE_KEY, mode);
}

type IntegrationScopeInput = {
  /** Czy plan użytkownika w ogóle obejmuje Performance (flaga z `/api/auth/me`). */
  planHasPerformance: boolean;
  /** `?context=` z linku, który przyprowadził usera do huba. */
  contextParam: string | null;
};

export type IntegrationScope = {
  /** Czy Centrum Integracji ma pokazywać karty, filtry i KPI z części reklamowej. */
  showPerformance: boolean;
  /** Czy pokazać przełącznik Organic | Reklamy. */
  canToggle: boolean;
};

/** Wartość `?context=`, którą wstawiają linki z części organicznej. */
export const ORGANIC_CONTEXT_PARAM = "organic";

/**
 * Czym jest zawężenie do Organica w hubie:
 *  - user bez Performance w planie widzi wąski hub zawsze (VP-116, ADR-0006) i nie ma czego
 *    przełączać — dla niego reklamy to upsell, nie zakładka;
 *  - user z Performance dostaje wąski hub tylko wtedy, gdy PRZYSZEDŁ z Organica, i wtedy
 *    dostaje też przełącznik z powrotem na pełną listę.
 *
 * Kontekst musi być JAWNY (`?context=organic` w linku). Zapamiętany tryb sidebara celowo
 * nie jest brany pod uwagę: do huba prowadzi kilkanaście linków z części reklamowej
 * (dashboard, kreator kampanii, Autopilot, ustawienia analityki) i domyślanie się kontekstu
 * z globalnego przełącznika zawężałoby hub także tam — łącznie z deep-linkami `?open=ghl`
 * do kart, których w wąskim widoku nie ma.
 */
export function resolveIntegrationScope({
  planHasPerformance,
  contextParam,
}: IntegrationScopeInput): IntegrationScope {
  if (!planHasPerformance) return { showPerformance: false, canToggle: false };

  const fromOrganic = contextParam === ORGANIC_CONTEXT_PARAM;
  return { showPerformance: !fromOrganic, canToggle: fromOrganic };
}
